export default "__VITE_ASSET__QhMR9mJB__"